import socket, { resetTimer } from './index';

export const socketFetchTickets = (query, recaptchaToken) => {
  resetTimer();
  const queryWithToken = { ...query, recaptchaToken };
  socket.emit('searchTickets', queryWithToken);
};
